import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useQuestions } from "src/context/QuestionsProvider";
import { QuestionTypes } from "../../constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ABTest from "src/components/ABTest";

const QuestionHeader = () => {
  const title = useQuestions((q) => q.title);
  const subtitle = useQuestions((q) => q.subtitle);
  const prompt = useQuestions((q) => q.prompt);
  const questionType = useQuestions((q) => q.question_type);
  const questionTag = useQuestions((q) => q.tag);
  const { t } = useTranslation();

  const variantTitle = useMemo(() => {
    return t(
      `question-header.allergies-variant-b.title`,
      "Do you have any allergies?",
    );
  }, [t]);

  if (
    [
      QuestionTypes.PROGRESS_PROJECTION,
      QuestionTypes.GLP1_PRELIMINARY_RESULTS,
      QuestionTypes.GLP1_REVIEWS,
      QuestionTypes.ED_OPTIONS,
      QuestionTypes.SHIPPING_INFORMATION,
      QuestionTypes.ID_VERIFICATION,
      QuestionTypes.PAYMENT_INFORMATION,
      QuestionTypes.PAYMENT_CONFIRMATION,
    ].includes(questionType) ||
    ["ED_RESULTS", "AMH_MESSAGE", "AMH_REVIEW", "AMH_PLAN"].includes(
      questionTag || "",
    )
  ) {
    return null;
  }

  return (
    <Stack gap="8px">
      {prompt ? (
        <Typography variant="subtitle1" fontStyle={"italic"}>
          {prompt}...
        </Typography>
      ) : null}
      {questionTag === "ALLERGY" ? (
        <ABTest
          variantA={
            <Typography variant="h5" fontWeight={700}>
              {title}
            </Typography>
          }
          variantB={
            <Typography variant="h5" fontWeight={700}>
              {variantTitle}
            </Typography>
          }
          control={
            <Typography variant="h5" fontWeight={700}>
              {title}
            </Typography>
          }
          testName="New allergies UI"
        />
      ) : (
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
      )}
      {subtitle ? <Typography>{subtitle}</Typography> : null}
    </Stack>
  );
};

export default QuestionHeader;
